module.exports = __webpack_public_path__ + "static/media/cab-q7.e4a6e1d9.jpg";